/**
 * Full page reload after a confirmed paid upgrade.
 *
 * A confirmed upgrade applies the authoritative plan to in-memory state and
 * repaints avatar/choosers, but plan-painted surfaces hydrated from pre-upgrade
 * server data stay stale — the profile plan badge, membership panel, AI quota,
 * home resume card. A full page reload re-reads every surface from the
 * authoritative session so nothing remains at the old tier. The small delay
 * lets the success toast paint first; unit tests disable it via
 * setPostUpgradePageRefresh(false).
 */
const POST_UPGRADE_RELOAD_DELAY_MS = 1_500;
let refreshPageOnConfirmedUpgrade = true;

export function setPostUpgradePageRefresh(enabled: boolean): void {
	refreshPageOnConfirmedUpgrade = enabled;
}

export function schedulePostUpgradePageRefresh(): void {
	if (!refreshPageOnConfirmedUpgrade) return;
	if (typeof window === 'undefined' || typeof window.location?.reload !== 'function') return;
	window.setTimeout(() => window.location.reload(), POST_UPGRADE_RELOAD_DELAY_MS);
}
